const APP_MODES = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development'
}

module.exports = {
  IS_DEVELOPMENT: process.env.NODE_ENV === APP_MODES.DEVELOPMENT,
  IS_PRODUCTION: process.env.NODE_ENV === APP_MODES.PRODUCTION,
  APP_MODES
}
